<template>
  <div class="textMessageTemplateOut">
    <div class="ps">簡訊內容不可有電話、URL、短網址。若必須包含可與簡訊業者/電信公司申請。(文中請勿包含『來電』、『電洽』、『客服專員』等，電話號碼請包含"-"或使用全形文字)<br>禁止使用的網域如下(包括但不限於): FB連結 , Line連結 , IG連結 , Tiktok連結, Youtube連結 , forms.gle , surveycake.com , tinyurl.com , pse.is , reurl.cc , bit.ly , goo.gl , is.gd, lihi.cc , lihi1.com , lihi2.com , lihi1.me , line.me , lin.ee , liff.line.me , ppt.cc …等</div>
    <div class="textMessageTemplate" v-if="info">
      <div>
        <div class="headerTitleTMT">● 會員{{info.storeType === 'shop' ? '訂購' : '預約'}}</div>
        <editCubeMsg :edit="editMsg==='0'" @edit="editMsg='0'" @cancel="editMsg=null" :isSwitch="'sendSuccessMessage'" :switchValue="info.sendSuccessMessage"
        :value="info.successMessage||''" :title="'訂購成功訊息'"  :notShop="info.storeType!=='shop'"
        @update="update({ successMessage: $event })" @updateSwitch="update({ sendSuccessMessage: $event })"
        :template="successTemplate"/>
        <editCubeMsg :edit="editMsg==='1'" @edit="editMsg='1'" @cancel="editMsg=null" :isSwitch="false"
        :value="info.remitConfirmMessage||''" :title="'付訂成功簡訊[後臺手動發送]'" :atm="true" :remit="true"  :notShop="info.storeType!=='shop'"
        @update="update({remitConfirmMessage: $event})"
        :template="confirmTemplate"/>
        <editCubeMsg :edit="editMsg==='2'" @edit="editMsg='2'" @cancel="editMsg=null" :isSwitch="false"
        :value="info.remitNotifyMessage||''" :title="'付訂資訊簡訊[後臺手動發送]'" :atm="true"  :notShop="info.storeType!=='shop'"
        @update="update({remitNotifyMessage: $event})"
        :template="notifyTemplate"/>

      </div>
      <div>
        <div class="headerTitleTMT">● 非會員{{info.storeType === 'shop' ? '訂購' : '預約'}}</div>
        <editCubeMsg :edit="editMsg==='4'" @edit="editMsg='4'" @cancel="editMsg=null" :isSwitch="false"
        :value="info.visitorOrderMessage_online||''" :title="'線上付款'" :notShop="info.storeType!=='shop'"
        @update="update({ visitorOrderMessage_online: $event })"/>
        <editCubeMsg :edit="editMsg==='5'" @edit="editMsg='5'" @cancel="editMsg=null" :isSwitch="false"
        :value="info.visitorOrderMessage_remit||''" :title="'匯款'" :atm="true"  :notShop="info.storeType!=='shop'"
        @update="update({visitorOrderMessage_remit: $event})"/>
        <editCubeMsg :edit="editMsg==='6'" @edit="editMsg='6'" @cancel="editMsg=null" :isSwitch="false"
        :value="info.visitorOrderMessage_onsite||''" :title="'現場結帳'" :atm="true"  :notShop="info.storeType!=='shop'"
        @update="update({visitorOrderMessage_onsite: $event})"/>
      </div>
    </div>
  </div>
</template>

<script>
import editCubeMsg from '../../components/editCubeMsgShop.vue'
export default {
  props: ['info'],
  components: {
    editCubeMsg
  },
  computed: {
    notifyTemplate () {
      switch (this.info.storeType) {
        case 'service':
          return `您好，感謝您預訂【${this.info.name}】{預約日期} {預約時間} 服務將收取訂金\nATM自動轉帳\n匯入銀行:ｏｏ銀行ｏｏｏｏ分行\n匯入帳號 :\n\n電匯\n解款行:ｏｏ銀行ｏｏｏｏ分行(000 0000)\n戶名:ｏｏｏｏ股份有限公司\n帳號:\n\n🔔本次訂金為{匯款金額}。\n1.請於預約後72小時內匯款預購完成，並告知轉帳末五碼。\n2.期限內未付訂金，位置將不予保留。\n3.若有疑問可來電。請勿回覆此簡訊。`
        case 'shop':
          return `您好，感謝您預訂【${this.info.name}】{預約日期} {預約時間} 將收取部分商品金額做為訂金\nATM自動轉帳\n匯入銀行:ｏｏ銀行ｏｏｏｏ分行\n匯入帳號 :\n\n電匯\n解款行:ｏｏ銀行ｏｏｏｏ分行(000 0000)\n戶名:ｏｏｏｏ股份有限公司\n帳號:\n\n🔔本次訂金為{匯款金額}。\n1.請於預約後72小時內匯款預購完成，並告知轉帳末五碼。\n2.期限內未付訂金，位置將不予保留，謝謝。\n3.若有疑問可來電。請勿回覆此簡訊。`
        default:
          return `您好，感謝您預訂{預約日期} {預約時間}於【${this.info.name}】用餐，用餐人數{人數}人。將收取收取部分商品金額做為訂金\n\nATM自動轉帳\n匯入銀行:ｏｏ銀行ｏｏｏｏ分行\n匯入帳號 :\n\n電匯\n解款行:ｏｏ銀行ｏｏｏｏ分行(000 0000)\n戶名:ｏｏｏｏ股份有限公司\n帳號:\n\n🔔本次訂金為{匯款金額}。\n1.請於預約後72小時內匯款預購完成，並告知轉帳末五碼以便完成訂位手續。\n2.期限內未付訂金，位置將不予保留。\n3.若有疑問可來電。請勿回覆此簡訊。`
      }
    },
    confirmTemplate () {
      switch (this.info.storeType) {
        case 'service':
          return `您好，感謝您預訂【${this.info.name}】{預約日期} {預約時間}\n已收到您支付訂金{匯款金額}元，\n當天請於預約時段到現場櫃檯報，期待您的蒞臨，謝謝。請勿回覆此簡訊。`
        case 'shop':
          return `您好，感謝您預訂【${this.info.name}】{預約日期} {預約時間}\n已收到您支付訂金{匯款金額}元，\n我們將會為您準備預定商品，請於預約時間到門市現場取貨，謝謝。請勿回覆此簡訊。`
        default:
          return `您好，感謝您預訂{預約日期} {預約時間}於【${this.info.name}】用餐，用餐人數{人數}人。\n已收到您支付訂金{匯款金額}元，\n期待您的蒞臨，謝謝。請勿回覆此簡訊。`
      }
    },
    successTemplate () {
      switch (this.info.storeType) {
        case 'service':
          return `您好，感謝您預訂【${this.info.name}】{預約日期} {預約時間}\n當日預約將保留十分鐘，請於預約時段到現場櫃檯報，期待您的蒞臨，謝謝。請勿回覆此簡訊。`
        case 'shop':
          return `您好，感謝您預訂【${this.info.name}】{預約日期} {預約時間}\n訂單確認後我們將會為您準備預定商品，請於預約時間到門市現場取貨，謝謝。請勿回覆此簡訊。`
        default:
          return `您好，感謝您預訂{預約日期} {預約時間}於【${this.info.name}】用餐，用餐人數{人數}人。\n當日座位將保留十分鐘，祝用餐愉快，期待您的蒞臨，謝謝。請勿回覆此簡訊。`
      }
    }
  },
  data () {
    return {
      editMsg: null
    }
  },
  watch: {
    info: {
      deep: true,
      immediate: true,
      handler () {
        this.editMsg = null
      }
    }
  },
  methods: {
    update (value) {
      this.$emit('update', value)
    }
  }

}
</script>

<style lang="scss" scoped>
.textMessageTemplateOut {
  display: grid;
  grid-template-rows: 90px calc(100vh - 180px);
  .ps {
    color: #999999;
    text-align: start;
    padding-inline: 40px;
    border-bottom: 1px solid #CACACA;
    align-items: center;
    display: flex;
  }
}
.textMessageTemplate {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  &>div:nth-child(1) {
    border-right: 1px solid #CACACA;
  }
  &>div {
    padding: 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
  .headerTitleTMT {
    text-align: start;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: .1em;
    margin-bottom: 10px;
    color: var(--color-pri);
  }
  position: relative;
}
</style>
